import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-key-features',
  templateUrl: './key-features.component.html',
  styleUrls: ['./key-features.component.scss']
})
export class KeyFeaturesComponent implements OnInit {

  public activeId: number = 1;
  constructor() { }

  ngOnInit() {
  }

}
